/**
 * 工具函数文件
 * 提供通用的工具函数
 */

import type { Position } from './types';

/**
 * 检查位置是否在网格范围内
 * @param position 位置坐标
 * @param size 网格大小
 * @returns 是否在范围内
 */
export function isWithinBounds(position: Position, size: number): boolean {
  return position.x >= 0 && position.x < size && position.y >= 0 && position.y < size;
}

/**
 * 比较两个位置是否相同
 * @param a 位置A
 * @param b 位置B
 * @returns 是否相同
 */
export function positionsEqual(a: Position, b: Position): boolean {
  return a.x === b.x && a.y === b.y;
}

/**
 * 生成指定范围内的随机整数
 * @param min 最小值（包含）
 * @param max 最大值（包含）
 * @returns 随机整数
 */
export function randomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * 从数组中随机选择一个元素
 * @param array 数组
 * @returns 随机元素，如果数组为空则返回undefined
 */
export function randomChoice<T>(array: T[]): T | undefined {
  if (array.length === 0) {
    return undefined;
  }
  return array[randomInt(0, array.length - 1)];
}

/**
 * 格式化数字（添加千位分隔符）
 * @param num 数字
 * @returns 格式化后的字符串
 */
export function formatNumber(num: number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 延迟执行
 * @param ms 延迟时间（毫秒）
 * @returns Promise
 */
export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * 深拷贝对象
 * @param obj 对象
 * @returns 深拷贝后的对象
 */
export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj)) as T;
}
